import styled from 'styled-components'

const TextColumnContainer = styled.div`
    #paywall-server {
        display: none;
    }
`

export default TextColumnContainer;